import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { CreditCardOfferButton } from '@cc-shopping/ui/composites/CreditCardOfferButton';
import { Box } from '@mui/material';
import { useCompareContext } from '../Context';
import type { CardOfferButtonWithAnalytics } from '../HorizontalScrollableCardList';
export const CreditCardOfferButtonContainer = t0 => {
  const $ = _c(16);
  const {
    cardOfferButton
  } = t0;
  const {
    idsToCompare,
    isLoading,
    addIdToCompare
  } = useCompareContext();
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t1;
  if ($[0] !== skuImpressionId) {
    t1 = {
      actionName: "cc_compare_select_card",
      actionSection: "cc_compare_category",
      actionType: "add",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fireSelectCardPageAction = usePageAction(t1);
  let t2;
  if ($[2] !== addIdToCompare || $[3] !== cardOfferButton.id || $[4] !== fireSelectCardPageAction) {
    t2 = () => {
      addIdToCompare(cardOfferButton.id);
      fireSelectCardPageAction();
    };
    $[2] = addIdToCompare;
    $[3] = cardOfferButton.id;
    $[4] = fireSelectCardPageAction;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleClick = t2;
  let t3;
  if ($[6] !== cardOfferButton.id || $[7] !== idsToCompare || $[8] !== isLoading) {
    t3 = isLoading || idsToCompare.includes(cardOfferButton.id);
    $[6] = cardOfferButton.id;
    $[7] = idsToCompare;
    $[8] = isLoading;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== cardOfferButton || $[11] !== t3) {
    t4 = <CreditCardOfferButton cardOfferButton={cardOfferButton} disabled={t3} />;
    $[10] = cardOfferButton;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== handleClick || $[14] !== t4) {
    t5 = <Box onClick={handleClick}>{t4}</Box>;
    $[13] = handleClick;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};